import axios from 'axios';
import { BASE_URL } from './api';



export async function getEmailTemplates(token) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/email-templates/get_simple_email_templates`,
        headers: {
            'Authorization': `Token ${token}`
        },
    }).then((response) => {
        // console.log("Email template results:" , response.data)
        return response.data;
    }).catch((error) => {
        throw error
    });

}

export async function getEmailTemplatesByQueryParams(token, queryParams) {
        return axios({
        method: 'get',
        url: `${BASE_URL}/email-templates${queryParams}`,
        headers: {
            'Authorization': `Token ${token}`
        },
    }).then((response) => {
        // console.log('Finished Running: getCompanies async call', response);
        return response
    }).catch((error) => {
        console.log(error)
    });
}

export async function getEmailTemplatesFullDetail(payload) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/email-templates/?${payload.endpoint}`,
        headers: {
            'Authorization': `Token ${payload.token}`
        },
    }).then((response) => {
        return {
            results: response.data.results,
            count: response.data.count,
            next: response.data.next,
            prev: response.data.previous,
            page: response.data.page,
            pageSize: response.data.page_size,
            numPages: response.data.num_pages,
        };
    }).catch((error) => {
        throw error
    });

}

export async function getLlmInterpretationFields(token) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/email-templates/get_llm_interpretation_fields`,
        headers: {
            'Authorization': `Token ${token}`
        },
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        throw error
    });
}

export async function getEmailsSendToAddresses(payload) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/email-templates/get_email_send_to_addresses`,
        headers: {
            'Authorization': `Token ${payload.token}`
        },
    }).then((response) => {
        return response
    }).catch((error) => {
        throw error
    });
}

export async function getEmailTemplateAddresses(token, queryParams) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/email-addresses${queryParams}`,
        headers: {
            'Authorization': `Token ${token}`
        },
    }).then((response) => {
        return response
    }).catch((error) => {
        throw error
    });
}

export async function createNewEmailTemplate(data, token) {
    return axios({
        method: "post",
        url: `${BASE_URL}/email-templates/`,
        // url: `${BASE_URL}/email-templates/create_new_email_template/`,
        headers: {
          Authorization: `Token ${token}`,
          "Content-Type": "multipart/form-data",
        },
        data: data,
      })
        .then((response) => response)
        .catch((error) => {
            console.log(error)
            return error
        });
}

export async function getEmailTemplate(emailTemplateId, token) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/email-templates/`,
        headers: {
            'Authorization': `Token ${token}`
        },
        params: {templateId: emailTemplateId}
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        throw error
    });
}

export async function uploadEmailTemplateAttachments(token, emailTemplateId, files) {
    const formData = new FormData()
    for (const file of files) {
        formData.append('file', file, file.name)
    }
    return axios({
        method: 'post',
        url: `${BASE_URL}/email-templates/${emailTemplateId}/attachments/`,
        headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'multipart/form-data'
        },
        data: formData
    }).then((response) => {
        return response.data
    }).catch((error) => {
        throw error
    })
}

export async function deleteEmailTemplateAttachment(token, emailTemplateId, attachmentId) {
    return axios({
        method: 'delete',
        url: `${BASE_URL}/email-templates/${emailTemplateId}/attachments/${attachmentId}/`,
        headers: {
            'Authorization': `Token ${token}`
        }
    }).then((response) => {
        return response
    }).catch((error) => {
        throw error
    })
}

export async function updateEmailTemplate(token, emailTemplateId, formData) {
    console.log(formData)
    return axios({
        method: 'put',
        url: `${BASE_URL}/email-templates/${emailTemplateId}/`,
        headers: { 
          'Authorization': `Token ${token}`, 
          'Content-Type': 'mulitpart/form-data'
        },
        data: formData
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
  }
